module.exports = __webpack_public_path__ + "img/波浪.20b5f76b.png";